export default {
    BASIC: 'Basic',
    FINANCIAL: 'Financial',
    ADMIN: 'Admin',
    ADMIN_PANEL_USER: 'Admin Panel User',
};
